import React, { useEffect } from 'react';
import SelectionTotalTracker from './SelectionTotalTracker.js';
import { PersonaliseInfo } from '../styles';
import PresetMessages from './common/PresetMessages.js';
import MobileSelectionDisplay from './Touch/MobileSelectionDisplay.js';
import SelectionItems from './SelectionItems.js';

const CurrentSelection = ({
  limit,
  selection,
  sizes,
  handleLimitChange,
  clearSelection,
  updateItemRemove,
  randomise,
  showMessages,
  setShowMessages,
  charLimit,
  rangeName,
  singleMessage,
  setSingleMessage,
  handleAddMessage,
  messages,
  disableMessage,
  handleShowMessages,
  handleSingleMessage,
  clearMultiMessage,
  singleMessageContent,
  currentRange,
  isMobile,
  setSelection,
  editable,
  setEditable,
  personalisationSelected,
  setPersonalisationSelected,
  expanded,
  setExpanded,
  firstMsg,
  setFirstMsg,
  presetMsg,
  setPresetMsg,
  isMini,
  getCharacterCount,
}) => {
  const toggleSingleMessage = () => {
    setSingleMessage(!singleMessage);
    if (singleMessage === false) {
      clearMultiMessage();
    }
  };

  useEffect(() => {
    let t = selection.filter((item) => item?.message);

    if (t.length && !firstMsg && !presetMsg) {
      setFirstMsg(t[0].bId);
    } else if (
      t.length >= 1 &&
      firstMsg &&
      !t.filter((item) => item.bId === firstMsg).length
    ) {
      setFirstMsg(t[0].bId);
    } else if ((!t.length && firstMsg) || (t.length && presetMsg)) {
      setFirstMsg(null);
    }
  }, [selection]);

  return (
    <>
      <SelectionTotalTracker
        selection={selection}
        limit={limit}
        sizes={sizes}
        handleLimitChange={handleLimitChange}
        randomise={randomise}
        isMobile={isMobile}
      />
      {currentRange.bundle_name === 'REG_OBJ' && personalisationSelected && (
        <PresetMessages
          presetMsg={presetMsg}
          setPresetMsg={setPresetMsg}
          handleSingleMessage={handleSingleMessage}
        />
      )}
      {personalisationSelected && selection.find((item) => item !== null) && (
        <PersonaliseInfo className={`py-2 mb-1`}>
          Total of{' '}
          <span>
            {
              selection.filter(
                (item) => item?.personalisation_available === 'Y'
              ).length
            }
          </span>
          <span>/{limit}</span> cupcakes can be personalised
        </PersonaliseInfo>
      )}

      <SelectionItems
        limit={limit}
        selection={selection}
        sizes={sizes}
        handleLimitChange={handleLimitChange}
        clearSelection={clearSelection}
        updateItemRemove={updateItemRemove}
        showMessages={showMessages}
        rangeName={rangeName}
        setSingleMessage={setSingleMessage}
        handleAddMessage={handleAddMessage}
        messages={messages}
        disableMessage={disableMessage}
        currentRange={currentRange}
        editable={editable}
        personalisationSelected={personalisationSelected}
        setPersonalisationSelected={setPersonalisationSelected}
        handleShowMessages={handleShowMessages}
        charLimit={charLimit}
        firstMsg={firstMsg}
        setFirstMsg={setFirstMsg}
        singleMessage={singleMessage}
        handleSingleMessage={handleSingleMessage}
        presetMsg={presetMsg}
        setPresetMsg={setPresetMsg}
        clearMultiMessage={clearMultiMessage}
        getCharacterCount={getCharacterCount}
        isMini={isMini}
      />
    </>
  );
};

export default CurrentSelection;
